<template>
    <v-dialog v-model="shows" persistent max-width="900">
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-if="isLoaded" height="100%">
            <v-card-title>
                작품상세정보 기본값 설정
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text v-if="isLoaded" class="pa-0" style="max-height: calc(90vh - 120px); overflow-y: auto">
                <work-view-classifications v-model="inputs.workClassifications" />
            </v-card-text>
            <v-divider />
            <v-card-actions class="px-4">
                <i class="subtitle-2">* <b>신규 작품 생성 시</b> 기본으로 불러오는 데이터입니다.</i>
                <v-spacer />
                <v-btn large color="primary" @click="save">
                    저장하기
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { initial_classifications } from "@/assets/variables";
import WorkViewClassifications from "./work-view-classifications.vue";

const initSetting = () => ({
    workClassifications: JSON.parse(JSON.stringify(initial_classifications)).map((item) => ({ ...item, _id: Math.random(), list: (item.list || []).map((listItem) => ({ ...listItem, _id: Math.random() })) })),
});

export default {
    components: {
        WorkViewClassifications,
    },
    props: {
        value: { type: Object },
    },
    data: () => ({
        shows: false,
        isLoaded: false,
        inputs: {},
    }),
    mounted() {
        if (this.shows) this.init();
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
    methods: {
        async init() {
            this.isLoaded = false;
            try {
                if (this.isCreate) {
                    this.inputs = { ...initSetting };
                } else {
                    const { setting } = await api.console.setting.get();
                    if ((setting?.workClassifications || []).length < 1) {
                        setting.workClassifications = JSON.parse(JSON.stringify(initial_classifications)).map((item) => ({ ...item, _id: Math.random(), list: (item.list || []).map((listItem) => ({ ...listItem, _id: Math.random() })) }));
                    }
                    this.inputs = { ...setting };
                }
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.isLoaded = true;
            }
        },

        validate() {},

        async save() {
            try {
                this.validate();

                // Document POST / PUT
                const { _id, workClassifications } = this.inputs;
                const { setting } = await api.console.setting.put({ _id, workClassifications });

                // Files POST / PUT

                alert("저장되었습니다");
                this.shows = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>
